import { render, staticRenderFns } from "./GouvernanceView.vue?vue&type=template&id=c0d6aa64&"
import script from "./GouvernanceView.vue?vue&type=script&lang=js&"
export * from "./GouvernanceView.vue?vue&type=script&lang=js&"
import style0 from "./GouvernanceView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports